import React, { useState, useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { useAddUpdateGlobalListMutation, useGetAllTagsQuery } from "../ActivityLogs/AuditLogAPIS";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as EditIcon } from "../../assets/images/icons/EditPencil.svg";
import { createOption, getOptions, updateOption } from "../../utils/api/customTemplatesApi";
import ChoiceField from "../GlobalFeature/Table/ChoiceField";
import InternalNavigation from "../Customize/InternalNavigation";

const GlobalTags = () => {
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [shadowColor, setShadowColor] = useState("");
  const [inputVisible, setInputVisible] = useState(false);
  const [allowMultiple, setAllowMultiple] = useState(false);
  const [isEmptyOption, setIsEmptyOption] = useState(false);
  const [EditFieldData, setEditFieldData] = useState(null);
  const [dropDownId, setDropdownId] = useState(null);
  const [isAddChoice, setIsAddChoice] = useState(false);

  const [extraFieldData, setExtraFieldData] = useState({
    field_name: "",
    field_label: "",
    field_options: [],
    field_type: "",
    field_description: "",
  });

  const [saveGlobalDropdown, { data: saveData, isLoading, isSuccess, isError, error }] =
    useAddUpdateGlobalListMutation();

  const {
    data: globalTagsData,
    isLoading: globalTagsLoading,
    isFetching: globalTagsFetching,
    isError: globalTagsError,
    error: globalTagsErrorData,
    isSuccess: globalTagsSuccess,
    refetch,
  } = useGetAllTagsQuery(undefined, {
    skip: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnMountOrArgChange: false,
  });

  const tableHeader = [
    { accessor_key: "template_name", label: "Template Name" },
    // { accessor_key: "field_name", label: "Field Name" },
    { accessor_key: "field_label", label: "Field Label" },
    // { accessor_key: "created_by", label: "Created By" },
  ];

  const handleEditClick = (item) => {
    console.log(item, "safhsdhf8787");

    setIsEdit(true);
    setDropdownId(item?.dropdown_id);
    setExtraFieldData((prev) => ({
      ...prev,
      field_name: item?.field_name || "",
      field_label: item?.field_label || "",
      field_description: item?.description || "",
      fieldId: item?.dropdown_id || "",
    }));

    handleGetOptions(item?.field_name);
  };

  const handleGetOptions = async (fieldName) => {
    try {
      const response = await getOptions({ query: { field_name: fieldName } });
      if (response?.status) {
        const fieldOptions = response?.data?.map((val) => ({
          value: val.label,
          color_code: val.color || "",
          id: val.id,
        }));
        setExtraFieldData((prev) => ({
          ...prev,
          field_options: fieldOptions,
        }));
        setEditFieldData({
          field_options: fieldOptions,
        });
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleAddClick = () => {
    setIsAddChoice(true);
    setDropdownId(null);
    setExtraFieldData({
      field_name: "",
      field_label: "",
      field_options: [],
      field_type: "",
      field_description: "",
    });
  };

  const handleFieldChange = (field, e) => {
    const newValue = e.target.value;
    setExtraFieldData((prevState) => ({
      ...prevState,
      [field]: newValue,
      ...(field === "field_label" && { field_name: newValue }),
    }));
  };

  const handleSave = () => {
    const isColorEnabled = extraFieldData.field_options.some((opt) => opt.color_code && opt.color_code.trim() !== "");

    const payload = {
      name: extraFieldData.field_name,
      label: extraFieldData.field_label,
      description: extraFieldData.field_description,
      is_color_enabled: isColorEnabled,
      values: extraFieldData.field_options.map((opt) => ({
        label: opt.value,
        color: opt.color_code || null,
      })),
    };

    if (dropDownId) {
      payload.id = dropDownId;
    }

    console.log("Payload sending to API:", payload);
    saveGlobalDropdown(payload);
  };

  const handleCancelButton = () => {
    setIsEdit(false);
    setIsAddChoice(false);
  };

  const removeChoiceApi = (fieldId, optionId) => {
    console.log(`Removing option ${optionId} from field ${fieldId}`);
  };

  const handleFieldOptionUpdate = async (updatedOption) => {
    console.log(updatedOption, "3556748578");

    try {
      const response = await updateOption({
        query: { field_name: extraFieldData.field_name },
        body: { id: updatedOption?.id, value: updatedOption?.value, color: updatedOption?.color_code },
      });

      if (response?.status) {
        dispatch(pushAlert({ visible: true, message: response?.message || "Success", type: "success" }));
        handleGetOptions(extraFieldData.field_name);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleFieldOptionAdd = async (newOption) => {
    try {
      let body = {
        value: newOption?.value,
        color: newOption?.color_code,
      };
      const response = await createOption({ query: { field_name: extraFieldData.field_name }, body });
      if (response?.status) {
        handleGetOptions(extraFieldData.field_name);
        dispatch(pushAlert({ visible: true, message: response?.message || "Success", type: "success" }));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    // Success handling
    if (isSuccess) {
      dispatch(
        pushAlert({
          message: saveData?.message || "List saved successfully",
          type: saveData?.success ? "success" : "danger",
          visible: true,
        })
      );

      if (saveData?.success) {
        refetch();

        setIsEdit(false);
        setIsAddChoice(false);
        setDropdownId(null);
        setExtraFieldData({
          field_name: "",
          field_label: "",
          field_options: [],
          field_type: "",
          field_description: "",
        });
        setEditFieldData(null);
        setInputValue("");
        setShadowColor("");
        setAllowMultiple(false);
        setIsEmptyOption(false);
      }
    }

    if (isError) {
      dispatch(
        pushAlert({
          message: error?.data?.message || "Failed to save list",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isLoading, isSuccess, isError]);

  return (
    <div className="p-3 w-full h-full">
      <p className="">
        <span className="text-md text-gray-500 italic">
          A single place to organize all the tags you use. Add, rename, or update tags once, and they automatically stay
          consistent everywhere. This helps you keep things neat, easy to find, and well-organized across your
          workspace.
        </span>
      </p>
      <div className="flex h-full gap-2">
        <div className="min-w-0 grow flex h-full">
          <ReactTableComponent
            tablename={<div className="text-base font-medium ">Manage Tags</div>}
            headers={tableHeader}
            body={globalTagsData?.data || []}
            actionColumn={(item) => (
              <div className="text-primary-60">
                <button onClick={() => handleEditClick(item)}>
                  <EditIcon className="fill-current" />
                </button>
              </div>
            )}
            // actionField={
            //   <span
            //     onClick={() => handleAddClick()}
            //     className="border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
            //   >
            //     <PlusIcon />
            //   </span>
            // }
          />
        </div>

        {(isEdit || isAddChoice) && (
          <div className="w-1/3 py-3 border border-[#DFE2E5] rounded h-full flex flex-col">
            <div className="flex justify-between items-center mb-4 border-b h-fit px-3 pb-2">
              <h4 className="text-sm font-medium">{dropDownId ? "Edit" : "Add"} List</h4>
              <button onClick={handleCancelButton}>
                <ClosePopUpIcn />
              </button>
            </div>

            {
              <div className="space-y-3 mb-4 grow min-h-0 flex flex-col px-3">
                {false && (
                  <div className="h-fit space-y-3">
                    <div className="flex flex-col font-400 text-sm w-full gap-1">
                      <label className="text-434852 font-poppins text-sm font-normal">
                        Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        className="h-8 pl-2 border-[#DFE2E5] rounded-md capitalize bg-white border focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 block w-full text-sm font-normal"
                        placeholder="Enter Detail"
                        defaultValue={extraFieldData?.field_label}
                        maxLength={25}
                        onBlur={(e) => handleFieldChange("field_label", e)}
                      />
                    </div>

                    <div className="flex flex-col font-400 text-sm w-full gap-1">
                      <label className="text-434852 font-poppins text-sm font-normal">Description</label>
                      <textarea
                        className="bg-white border h-20 focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 text-sm font-normal block w-full border-[#DFE2E5] rounded-md placeholder-[rgba(56,56,56,0.40)]"
                        defaultValue={extraFieldData?.field_description}
                        onBlur={(e) => handleFieldChange("field_description", e)}
                        rows="8"
                        placeholder="Type Something..."
                      />
                    </div>
                  </div>
                )}

                <div className="flex flex-col min-h-0 grow">
                  <ChoiceField
                    setExtraFieldData={setExtraFieldData}
                    extraFieldData={extraFieldData}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                    setShadowColor={setShadowColor}
                    shadowColor={shadowColor}
                    setInputVisible={setInputVisible}
                    InputVisible={inputVisible}
                    allowMultiple={allowMultiple}
                    setAllowMultiple={setAllowMultiple}
                    EditFieldData={EditFieldData}
                    setIsEmptyOption={setIsEmptyOption}
                    isEmptyOption={isEmptyOption}
                    removeChoiceApi={removeChoiceApi}
                    // isEditableMode={!!dropDownId}
                    handleFieldOptionUpdate={handleFieldOptionUpdate}
                    handleFieldOptionAdd={handleFieldOptionAdd}
                    isTagsField
                  />
                </div>
              </div>
            }

            {false && (
              <div className="flex justify-end gap-3 pr-2">
                <Button variant={"secondary"} onClick={handleCancelButton} className="p-3">
                  Cancel
                </Button>
                <Button variant={"primary"} onClick={handleSave} className="p-3">
                  {dropDownId ? "Update" : "Save"}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalTags;
